import { render, staticRenderFns } from "./SelectPermissionModal.vue?vue&type=template&id=11626c15&"
import script from "./SelectPermissionModal.vue?vue&type=script&lang=js&"
export * from "./SelectPermissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports